import BaseObject from './BaseObject.js';
import appConfig from '../../config/app_config';

export default class BatchGroupObject {
  static _objectDefinition(object = null) {
    if (object !== null && object.hasOwnProperty('Name')) {
      return object;
    }
    return {
      Orderable: 0,
      EventId: null,
      LocationId: null,
      Name: '',
      StartTime: null,
      EndTime: null,
      StartBatchFrequency: '',
      EndBatchFrequency: '',
      MaxInflow: null,
      FlexPercentage: '0',
      RatePrice: '0',
      RewardPoints: '0',
      StartDate: null,
      EndDate: null,
      NrOfRegistrations: 0,
      BookingPolicy: 0,
      PriceCategories: {},
      MaxOutflow: 0,
      MinArrivalTime: null,
      MaxArrivalTime: null,
      MinDepartureTime: null,
      MaxDepartureTime: null,
      ArrivalBatchDuration: 0,
      DepartureBatchDuration: 0,
      BatchDuration: '0',
      Unit: '',
      Steps: 1,
      MinBookingDuration: 1,
      MaxBookingDuration: 1,
      PricePercentage: 100,
    };
  }

  static _getStringHours(time) {
    let stringTime = '';
    const startH = (time.getHours() < 10 ? '0' : '') + time.getHours();
    const startM = (time.getMinutes() < 10 ? '0' : '') + time.getMinutes();
    stringTime = `${startH}:${startM}`;
    return stringTime;
  }

  static _getStringDate(time) {}

  static _createEventRepeatRequestObject(object, daySelected, event) {
    const parseDates = {};
    daySelected.forEach((element) => {
      parseDates[element] = element;
    });

    const requestObject = {
      Orderable: object.Orderable,
      EventId: event.eventId,
      LocationId: event.locationId,
      Name: object.Name,
      StartTime: object.StartTime,
      EndTime: object.EndTime,
      BatchDuration: object.BatchDuration,
      RatePrice: Number(object.RatePrice).toFixed(2),
      FlexPercentage: Number(object.FlexPercentage),
      RewardPoints: Number(object.RewardPoints),
      NrOfRegistrations: 0,
      Type: 'Repeating',
      StartDate: object.StartDate,
      EndDate: object.EndDate,
      Days: parseDates,
      BookingPolicy: Number(object.BookingPolicy),
      PriceCategories: object.PriceCategories,
      MinArrivalTime: object.MinArrivalTime,
      MaxArrivalTime: object.MaxArrivalTime,
      MinDepartureTime: object.MinDepartureTime,
      MaxDepartureTime: object.MaxDepartureTime,
      Unit: object.Unit,
      Steps: object.Steps,
      MinBookingDuration: object.MinBookingDuration,
      MaxBookingDuration: object.MaxBookingDuration,
    };
    const calculatedPricePercentage = Number(object.PricePercentage / 100.0);
    requestObject.PricePercentage = calculatedPricePercentage.toFixed(2);
    requestObject.ArrivalBatchDuration = Number(object.ArrivalBatchDuration) * 60;
    requestObject.DepartureBatchDuration = Number(object.DepartureBatchDuration) * 60;
    requestObject.StartBatchFrequency = event.type === 'Fixed' ? Number(object.ArrivalBatchDuration) * 60 : Number(object.StartBatchFrequency) * 60;
    requestObject.EndBatchFrequency = event.type === 'Fixed' ? Number(object.DepartureBatchDuration) * 60 : Number(object.EndBatchFrequency) * 60;
    requestObject.BatchDuration = Number(object.BatchDuration) * 60;
    requestObject.MaxInflow = Number(object.MaxInflow);
    requestObject.MaxOutflow = Number(object.MaxOutflow);
    (object.LocationId !== ''
        && object.LocationId !== undefined
        && object.LocationId !== null)
      ? requestObject.LocationId = object.LocationId
      : requestObject.LocationId = event.locationId;

    return requestObject;
  }

  static _createEventSpecificRequestObject(object, selectDates, event) {
    // sort dates based on inserted ones
    selectDates.sort((a, b) => {
      const a1 = a.split('-').join('');
      const b1 = b.split('-').join('');
      return a1 > b1 ? 1 : a1 < b1 ? -1 : 0;
    });

    const parseSelectedDates = {};
    selectDates.forEach((element) => {
      const correctDate = new Date(element).toLocaleDateString('nl-NL').split('/').join('-');
      parseSelectedDates[correctDate] = correctDate;
    });
    const requestObject = {
      Orderable: object.Orderable,
      EventId: event.eventId,
      LocationId: event.locationId,
      Name: object.Name,
      StartTime: object.StartTime,
      EndTime: object.EndTime,
      BatchDuration: object.BatchDuration,
      RatePrice: Number(object.RatePrice).toFixed(2),
      FlexPercentage: Number(object.FlexPercentage),
      RewardPoints: Number(object.RewardPoints),
      NrOfRegistrations: 0,
      Type: 'Specific',
      Dates: parseSelectedDates,
      BookingPolicy: Number(object.BookingPolicy),
      PriceCategories: object.PriceCategories,
      MinArrivalTime: object.MinArrivalTime,
      MaxArrivalTime: object.MaxArrivalTime,
      MinDepartureTime: object.MinDepartureTime,
      MaxDepartureTime: object.MaxDepartureTime,
      Unit: object.Unit,
      Steps: object.Steps,
      MinBookingDuration: object.MinBookingDuration,
      MaxBookingDuration: object.MaxBookingDuration,
    };

    const calculatedPricePercentage = Number(object.PricePercentage / 100.0);
    requestObject.PricePercentage = Number(calculatedPricePercentage.toFixed(2));
    requestObject.ArrivalBatchDuration = Number(object.ArrivalBatchDuration) * 60;
    requestObject.DepartureBatchDuration = Number(object.DepartureBatchDuration) * 60;
    requestObject.StartBatchFrequency = event.type == 'Fixed' ? Number(object.ArrivalBatchDuration) * 60 : Number(object.StartBatchFrequency) * 60;
    requestObject.EndBatchFrequency = event.type == 'Fixed' ? Number(object.DepartureBatchDuration) * 60 : Number(object.EndBatchFrequency) * 60;
    requestObject.BatchDuration = Number(object.BatchDuration) * 60;
    requestObject.MaxInflow = Number(object.MaxInflow);
    requestObject.MaxOutflow = Number(object.MaxOutflow);
    (object.LocationId !== ''
      && object.LocationId !== undefined
      && object.LocationId !== null)
      ? requestObject.LocationId = object.LocationId
      : requestObject.LocationId = event.locationId;

    return requestObject;
  }

  static _deleteRequestBatchgroup(object) {
    const reqObj = {
      BatchGroupId: Number(object.BatchGroupId),
      Type: object.Type,
    };
    return reqObj;
  }

  static _createArrayWithObjects(batchGroup) {
    const result = BaseObject._createArrayWithObjects(batchGroup);

    return result;
  }
}
